import React from "react";
import "./FeaturesSection.scss";

import {
  FiCompass,
  FiFolder,
  FiAward,
  FiTrendingUp,
  FiMessageCircle,
  FiBarChart2,
} from "react-icons/fi";

const features = [
  {
    icon: <FiCompass />,
    title: "Orientation",
    description:
      "Formulaire en ligne, évaluation automatique et recommandations personnalisées.",
    color: "#F59E0B",
  },
  {
    icon: <FiFolder />,
    title: "Dossier unique",
    description:
      "Un dossier partagé en temps réel avec les bons acteurs.",
    color: "#10B981",
  },
  {
    icon: <FiAward />,
    title: "Allocation",
    description:
      "Mise en relation femme–association et affectation d'un formateur.",
    color: "#FBBF24",
  },
  {
    icon: <FiTrendingUp />,
    title: "Suivi de progression",
    description:
      "Notes, évaluations, présence et attestations en temps réel.",
    color: "#EF4444",
  },
  {
    icon: <FiMessageCircle />,
    title: "Communication",
    description:
      "Messagerie intégrée, notifications et partage de documents.",
    color: "#60A5FA",
  },
  {
    icon: <FiBarChart2 />,
    title: "Tableaux de bord",
    description:
      "Indicateurs clés en temps réel et rapports statistiques.",
    color: "#34D399",
  },
];

const FeaturesSection = () => {
  return (
    <section className="features-section">
      <div className="container">

        <div className="section-title">
          <h2>Un accompagnement complet, à chaque étape</h2>
        </div>

        <div className="features-grid">

          {features.map((feature, index) => (
            <div className="feature-card" key={index}>

              <div
                className="feature-icon"
                style={{ color: feature.color }}
              >
                {feature.icon}
              </div>

              <h3>{feature.title}</h3>

              <p>{feature.description}</p>

            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;